import React, {useEffect, useState} from 'react';

import {useRecoilState, useRecoilValue} from 'recoil';
import {selectedMenu, subMenuState} from 'state';
import styled, {keyframes} from 'styled-components';

import LogoImg from '../../../assets/images/logo.png';
import BtnIcon from "../../../assets/images/icon/menu.png";
import {useWindowDimensions} from "../../../hooks/useWindowDimensions";

interface StyledComponentProps {
    active?: boolean;
    display?: boolean;
}
interface SideMenuContainerProps {
    children: React.ReactNode
}

const fadeIn = keyframes`
  from {
    transform: translateX(-20px); /* 위에서 내려오는 효과를 줍니다. */
    //opacity: 0; /* 투명도를 0으로 설정하여 처음에는 보이지 않도록 합니다. */
  }

  to {
    transform: translateX(0); /* 위치를 변화시켜 아래로 이동합니다. */
    //opacity: 1; /* 투명도를 1로 설정하여 완전히 보이도록 합니다. */
  }
`;
const isMobile = window.innerWidth < 768;
const SideMenuContainer:React.FC<SideMenuContainerProps> = ({children}) => {
    const [active, setWidth] = useState(!isMobile)
    const selectedSubMenu = useRecoilValue(subMenuState);
    const [selected, setSelected] = useRecoilState(selectedMenu)
    const {width, height} = useWindowDimensions()
    const onClickMenu = (item:string) => {
        setSelected(item)
    }

    useEffect(() => {
        if(width < 768){
            setWidth(false)
        }
    }, [selectedSubMenu, width]);
return(
  <Container active={active}>
    <Logo display={active}>
        <img src={LogoImg} alt="" />
    </Logo>
      <MenuBtn className={!active ? "close" : ""} onClick={() => setWidth(v => !v)}>
          {/*<img src={BtnIcon} alt="" />*/}
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="20" fill="#F5F5F5"/>
              <path d="M10 13H30" stroke="#333333" strokeWidth={1.6} strokeLinecap={"round"}/>
              <path d="M10 20H30" stroke="#333333" strokeWidth={1.6} strokeLinecap={"round"}/>
              <path d="M10 27H30" stroke="#333333" strokeWidth={1.6} strokeLinecap={"round"}/>
          </svg>

      </MenuBtn>
      <Menu active={active} onClick={() => {
          // setWidth(v => !v)
      }}>
          {children}
      </Menu>
  </Container>
)

}
export {SideMenuContainer};

const Container = styled.div.withConfig({
    shouldForwardProp: (prop) => !['active', 'display'].includes(prop),
})<StyledComponentProps>`
    animation: ${fadeIn} 0.4s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    transition: all 0.3s;
    width: ${props => props.active ? 289 : 72}px;
    z-index: 9999999;
    height: 100vh;
    background: #fff;
    border-right: solid 1px rgba(51, 51, 51, 0.3);
    padding: 0 7px 15px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    @media screen and (max-width: 768px) {
        width: ${props => props.active ? "50%" : 0}px;
        padding: 0;
    }
`;

const Logo = styled.div.withConfig({
    shouldForwardProp: (prop) => !['active', 'display'].includes(prop),
})<StyledComponentProps>`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 32px 0;
    border-bottom: solid 1px rgba(51, 51, 51, 0.3);
    opacity: ${props => !props.display ? 0 : 1};
    
    img{
        transform: scale(0.8);
        display: block;
        width: 180px;
        height: 37px;
        object-fit: cover;
    }
`;

const MenuBtn = styled.div`
    position: absolute;
    transition: all 0.2s;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    right: 0px;
    top: 100px;
    cursor: pointer;
    transform: translate(50%, -50%);

    img {
        display: block;
        width: 100%;
        height: 100%;
    }  

    svg {
        border-radius: 50%;
        transition: all 0.2s;
        circle {
            
        }
    }

    &:hover {
        svg {
            box-shadow: 2px 1px 3px 0px rgba(51, 51, 51, 0.3);
            circle {
              
                //fill: rgba(229, 229, 229, 0.95);
                //filter: drop-shadow(-1px -1px -1px black);
                //filter: grayscale(70%);
            }
        }
    }

    @media screen and (max-width: 768px) {
        top: 30px;
        &.close {
            right: calc(100% - 30px);
        }
    }
`;

const Menu = styled.div.withConfig({
    shouldForwardProp: (prop) => !['active', 'display'].includes(prop),
})<StyledComponentProps>`
    width: 100%;
    margin-top: 5px;
    overflow-y: scroll;
    height: calc(100vh - 200px)!important;
    max-height: calc(100vh - 200px)!important;
    flex: 1;
    position: relative;
    opacity: ${props => props.active ? 1 : 0};
    
    @media screen and (max-width: 768px) {
        
        padding: ${props => props.active ? 20 : 0}px;
    }
    &::-webkit-scrollbar {
        width: 3px;
        position: absolute;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        width: 10px;
        border-radius: 4px;
        position: absolute;

    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
        position: absolute;
    }
`;
